import { useMutation, useQuery } from '@tanstack/react-query';
import type { Query } from '@tanstack/react-query';

import { AssemblyAITranscriptResponse } from '../types/assemblyai';

export const useTranscription = () => {
  const submitTranscription = useMutation({
    mutationFn: async (videoBlob: Blob) => {
      const response = await fetch('/api/transcribe', {
        method: 'POST',
        body: videoBlob,
        headers: {
          'Content-Type': 'video/webm',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to submit transcription');
      }

      return response.json() as Promise<AssemblyAITranscriptResponse>;
    },
  });

  const getTranscriptionStatus = (transcriptId: string | null) => {
    return useQuery({
      queryKey: ['transcription', transcriptId],
      queryFn: async () => {
        if (!transcriptId) return null;

        const response = await fetch(`/api/transcribe?id=${transcriptId}`);
        if (!response.ok) {
          throw new Error('Failed to get transcription status');
        }

        return response.json() as Promise<AssemblyAITranscriptResponse>;
      },
      enabled: !!transcriptId,
      refetchInterval: (
        query: Query<AssemblyAITranscriptResponse | null, Error>
      ) => {
        const data = query.state.data;
        return data && data.status !== 'completed' && data.status !== 'error'
          ? 2000
          : false;
      },
    });
  };

  return {
    submitTranscription,
    getTranscriptionStatus,
  };
};
